<template>
  <CollapsibleComponent
    :multiple="true"
    :slots="slotsComputed">

    <template v-for="(slot, index) in valueLocal" :slot="slot.name">
      <GroupSingleLineComponent
        v-for="(data, dataIndex) in slot.data" :key="`slot.name ${index} data index ${dataIndex}`"
        v-bind="slot"
        :slots="[
          {
            name: 'admin',
            show: data.admin
          }
        ]"
        :img-src="data.imgSrc"
        v-model="valueLocal[index].data[dataIndex].value"
        @deleted="onDeleted(data, index, dataIndex)"
        @created="onCreated(data, index, dataIndex)"
        @edited="onEdited(data, index, dataIndex)"
        @editAborted="onEditAborted(data, index, dataIndex)">
        <template v-slot:warning-left>
          <slot :name="`${slot.name}.warning-left`"></slot>
        </template>
        <template v-slot:warning-right>
          <slot :name="`${slot.name}.warning-right`" v-bind:data="toRef(slot.data, dataIndex)"></slot>
        </template>
        <template v-slot:admin>
          <AdminIcon/>
          <span class="user-group-name">Administrator</span>
        </template>
      </GroupSingleLineComponent>

      <v-row justify="center" :key="`add icon ${index}`" v-if="slot.showNewButton">
        <v-col cols="auto">
          <ButtonTertiaryAction @click="onNew(index)">
            <template v-slot:text>{{ slot.newButtonText }}</template>
          </ButtonTertiaryAction>
        </v-col>
      </v-row>

    </template>

  </CollapsibleComponent>

</template>

<script>
import {computed, reactive, ref, watch, toRef} from '@vue/composition-api';

import GroupSingleLineComponent from "@/components/group/profile/GroupSingleLineComponent";
import CollapsibleComponent from "@/components/profile/CollapsibleComponent";
import {states} from "@/components/group/profile/GroupSingleLineComponent";
import AdminIcon from "@/components/icons/AdminIcon";
import ButtonTertiaryAction from "@/components/buttons/ButtonTertiaryAction";

export default {
  name: "GroupProfileComponent",
  components: {
    ButtonTertiaryAction,
    AdminIcon, CollapsibleComponent, GroupSingleLineComponent
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  setup(props, {emit}) {

    const slotsComputed = computed(() => {
      return props.value.map(slot => {
        return {slot: slot.name, title: slot.title}
      })
    })

    const valueLocal = ref(props.value.map(value => Object.assign({}, {
      ...value,
      data: value.data.map(dataObject => Object.assign({}, dataObject))
    })))
    watch(
      () => props.groupProfileData,
      () => {
        valueLocal.value = props.value.map(value => Object.assign({}, {
          ...value,
          data: value.data.map(dataObject => Object.assign({}, dataObject))
        }))
      },
      {deep: true}
    )

    function onNew(slotIndex) {
      valueLocal.value[slotIndex].data.push(reactive({value: {text: '', state: states.CREATE}}))
    }

    function onDeleted(dataObject, slotIndex, dataIndex) {
      props.value[slotIndex].data.splice(dataIndex, 1)
      valueLocal.value[slotIndex].data.splice(dataIndex, 1)
      emit('deleted', dataObject, slotIndex, dataIndex)
    }

    function onCreated(dataObject, slotIndex, dataIndex) {
      props.value[slotIndex].data.splice(dataIndex, 1, Object.assign({}, dataObject))
      emit('created', dataObject, slotIndex, dataIndex)
    }

    function onEdited(dataObject, slotIndex, dataIndex) {
      props.value[slotIndex].data.splice(dataIndex, 1, Object.assign({}, dataObject))
      emit('edited', dataObject, slotIndex, dataIndex)
    }

    function onEditAborted(dataObject, slotIndex, dataIndex) {
      valueLocal.value[slotIndex].data.splice(dataIndex, 1, Object.assign({}, Object.assign({}, props.value[slotIndex]).data[dataIndex]))
      emit('editAborted', dataObject, slotIndex, dataIndex)
    }


    return {slotsComputed, valueLocal, onNew, onDeleted, onCreated, onEdited, onEditAborted, toRef}
  }
}
</script>

<style scoped>

</style>
